import "./about.css";
import { ReactComponent as FirstIcon } from "../../Components/assets/icons/about_icon_one.svg";
import { ReactComponent as SecondIcon } from "../../Components/assets/icons/about_icon_two.svg";
import { ReactComponent as ThirdIcon } from "../../Components/assets/icons/about_icon_three.svg";
import Container from "../../Components/common/Container";
import HeroSection from "../../Components/About/HeroSection";
import OurVision from "../../Components/About/OurVision";
import SmartFinanceSection from "../../Components/About/SmartFinanceSection";
import ChooseUs from "../../Components/About/ChooseUs";
import UniquePoints from "../../Components/About/UniquePoints";

const AboutPage = () => {
  return (
    <div className="about-page">
      <div className="icons">
        <FirstIcon className="first-icon" />
        <SecondIcon className="second-icon" />
        <ThirdIcon className="third-icon" />
      </div>
      <Container>
        <HeroSection />
        <OurVision />
      </Container>
      <div className="smart-cards">
        <Container>
          <SmartFinanceSection />
        </Container>
      </div>
      <Container>
        <ChooseUs />
      </Container>
      <UniquePoints />
    </div>
  );
};

export default AboutPage;
